<template>
  <full-screen-loading />
</template>

<script>
import FullScreenLoading from '@/components/FullScreenLoading';
import { mapActions, mapGetters } from 'vuex';
import { ROUTES, CATERING_ROLE } from '../constants';

export default {
  components: {
    FullScreenLoading,
  },
  computed: {},
  methods: {
    ...mapGetters('user', { getUser: 'getUser' }),
    ...mapActions('user', { initializeUser: 'initializeUser' }),
    ...mapActions('diets', { initializeDiets: 'initializeDiets' }),
    ...mapActions('offices', { initializeOffices: 'initializeOffices' }),
    ...mapActions('allergies', { initializeAllergies: 'initializeAllergies' }),
    // This is useful to initialize resources only one time
    async initializeResources(user) {
      // We don't need allergies if we are catering
      if (user.role !== CATERING_ROLE) {
        this.initializeAllergies();
      }
      this.initializeOffices();
      this.initializeDiets();
      // We can wait for all promises to resolve, but we can let them resolve in the background
    },
    async handleLoginEvent(data) {
      await this.initializeUser();
      const user = this.getUser();
      this.initializeResources(user);
      if (data.error) {
        localStorage.clear();
        this.$router.push(ROUTES.HOME);
        return;
      }
      if (user.role === CATERING_ROLE) {
        this.$router.push(ROUTES.CATERING);
      } else {
        this.$router.push(ROUTES.MENU);
      }
    },
  },
  async created() {
    try {
      await this.$auth0.handleAuthentication();
    } catch (e) {
      this.$router.push({
        path: ROUTES.HOME,
        query: { error: e.errorDescription },
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/CallbackAuth0Page.vue